import { History } from 'history';
import React from 'react';
import { Route } from 'react-router';

export type UrlSearch = {
  readonly value: string;
  readonly update: (newValue: string) => void;
};

export type UrlSearchProviderProps = {
  readonly children: (urlSearch: UrlSearch) => React.ReactNode;
};

export class UrlSearchProvider extends React.Component<UrlSearchProviderProps> {

  public override render() {
    return (
      <Route>
        {({ history }) => (
          <UrlSearchProviderInternal history={history}>
            {this.props.children}
          </UrlSearchProviderInternal>
        )}
      </Route>
    );
  }

}

type UrlSearchProviderInternalProps = {
  readonly history: History;
  readonly children: (urlSearch: UrlSearch) => React.ReactNode;
};

class UrlSearchProviderInternal extends React.Component<UrlSearchProviderInternalProps> {

  public override render() {
    return (
      this.props.children({
        value: this.props.history.location.search,
        update: this.update,
      })
    );
  }

  private readonly update = (newValue: string) => {
    if (newValue === this.props.history.location.search) {
      return;
    }

    const history = this.props.history;
    history.replace({
      pathname: history.location.pathname,
      search: newValue,
    });
  }

}
